import React from 'react'
import { useIntl } from 'react-intl'

import TwButton, { BUTTON_VARIANTS } from 'components/Button/TwButton'
import {
  Document as DocumentIcon,
  History as PreviousDocumentIcon,
} from 'components/Icons'
import { useOfMinWidth } from 'hooks'
import { APP_BREAKPOINTS } from 'consts'

import messages from './messages'

const DocumentTile = ({
  title,
  currentDocumentUrl,
  previousVersionFileUrl,
}) => {
  const isTablet = useOfMinWidth(APP_BREAKPOINTS.TABLET_START)
  const { formatMessage } = useIntl()

  return (
    <div className="bg-grey-200 rounded-2xl p-4 gap-4 flex flex-col justify-between md:p-6 md:gap-6">
      <span className="text-h4 md:text-h3">{title}</span>
      <div className="flex gap-2">
        <TwButton
          variant={BUTTON_VARIANTS.secondary}
          onClick={() => window.open(`https:${currentDocumentUrl}`, '_blank')}
        >
          <div className="flex items-center gap-2">
            <DocumentIcon className="*:stroke-blue-900" />
            <span className="text-label-13md">
              {formatMessage(messages.currentFileBtn)}
            </span>
          </div>
        </TwButton>
        {previousVersionFileUrl && (
          <TwButton
            variant={BUTTON_VARIANTS.secondary}
            onClick={() =>
              window.open(`https:${previousVersionFileUrl}`, '_blank')
            }
          >
            <div className="flex items-center gap-2">
              {isTablet && (
                <PreviousDocumentIcon className="*:stroke-blue-900" />
              )}
              <span className="text-label-13md">
                {formatMessage(messages.previousFileBtn)}
              </span>
            </div>
          </TwButton>
        )}
      </div>
    </div>
  )
}

export default DocumentTile
